__turbopack_context__.v({
  "container": "NewPartialArticleLayout-module-scss-module__JvckGa__container",
});
